let modals = require( './modals' );

let quick_view_cart = (function( $ ) {

	let $html,
		$cart,
		transition_timeout,
		anim_speed = 400,
		// Add form ids here to automatically update the cart on successful submission
		form_ids = [
			'#standard-add-to-cart',
			'#manager-standard-add-to-cart',
			'#red-whale-add-to-cart',
			'#manager-red-whale-add-to-cart'
		];

	let _init = function() {
		$html = $( 'html' );
		$cart = $( '#quick-view-cart' );

		if ( $cart.length > 0 ) {
			transition_timeout = parseInt( $cart.css( 'transition-duration' ) ) * 1000;

			$( document ).on( 'toggle-quick-view-cart', toggle );
			$( document ).on( 'open-quick-view-cart', open );
			$( document ).on( 'close-quick-view-cart', close );
			$( document ).on( 'update-quick-view-cart', update );

			$( '.overlay' ).on( 'click', close );

			setup_triggers();
			setup_update_triggers();
			_setup_quick_view_cart_actions();
		}
	};

	let setup_triggers = function() {
		let $toggles = $( '.toggle-quick-view-cart' );

		$toggles.each( ( index, item ) => {
			let $toggle = $( item );

			if ( ! $toggle.hasClass( 'setup-toggle' ) ) {
				$toggle.on( 'click', function( e ) {
					e.preventDefault();
					toggle();
				} );
				$toggle.addClass( 'setup-toggle' );
			}
		} );
	};

	let _setup_quick_view_cart_actions = function() {
		$cart.find( 'a.remove-item' ).not( '.setup-remove' ).on( 'click', function ( e ) {
			e.preventDefault();

			_remove_cart_item( $( this ).data( 'item-id' ) );
		} );

		$cart.find( 'a.remove-item' ).addClass( 'setup-remove' );
	};

	let _remove_cart_item = function( item_id ) {
		$cart.addClass( 'loading' );

		let data = {
			nonce: ScriptData.remove_basket_item_nonce,
			action: 'crate_remove_basket_item',
			item_id: item_id,
		};

		$.post( ScriptData.ajaxurl, data, ( response ) => {
			if ( response.success ) {
				update();
			} else {
				$cart.removeClass( 'loading' );
				window.location.reload() // error removing item refresh page
			}
		} );
	};

	let setup_update_triggers = function() {
		form_ids.forEach( ( value, index ) => {
			$( value ).on( 'submit_success', update );
		} );
	};

	let toggle = function() {
		if ( $cart.hasClass( 'animating' ) ) {
			return;
		}

		$cart.addClass( 'animating' );

		if ( $html.hasClass( 'open-quick-view-cart' ) ) {
			close();
		} else {
			open();
		}

		setTimeout( () => {
			$cart.removeClass( 'animating' );
		}, anim_speed );
	};

	let open = function() {
		modals.close_all_modals();

		$html.addClass( 'open-quick-view-cart' );
		$html.addClass( 'opening-quick-view-cart' );

		setTimeout( function() {
			$html.removeClass( 'opening-quick-view-cart' );
		}, transition_timeout );
	};

	let close = function() {
		$html.removeClass( 'open-quick-view-cart' );
		$html.addClass( 'closing-quick-view-cart' );

		setTimeout( function() {
			$html.removeClass( 'closing-quick-view-cart' );
		}, transition_timeout );
	};

	let update = function() {
		$cart.addClass( 'loading' );

		let data = {
			action: 'crate_get_quick_view_cart_html',
			nonce: ScriptData.crate_get_quick_view_cart_html
		};

		$.post( ScriptData.ajaxurl, data, function( response ) {
			if ( response.success ) {
				$cart.find( '#quick-view-cart-items' ).remove();
				$cart.append( response.html ).append ( () => {
						_setup_quick_view_cart_actions();
					}
				);
				_update_toggle( parseInt( response.count ) );
			} else {
				// Error retrieving cart so reload page
				window.location.reload();
			}

			$cart.removeClass( 'loading' );
		} );
	};

	let _update_toggle = function( count ) {
		let $wrapper = $( '#quick-view-cart-toggle' );

		if ( count > 0 ) {
			$wrapper.removeClass( 'hidden' );
		} else {
			$wrapper.addClass( 'hidden' );
		}

		$wrapper.find( '.cart-count' ).text( count )
	};

	$( document ).ready( _init );

	return {
		setup_triggers: setup_triggers,
		toggle: toggle,
		open: open,
		close: close,
		update: update,
		setup_update_triggers: setup_update_triggers,
	};

})( jQuery );

module.exports = quick_view_cart;